import Compressor from 'compressorjs';

export const getCompressedImage = (file, callback, errorCallback) => {
  new Compressor(file, {
    quality: 0.7,
    success(result) {
      callback(result);
    },
    error(error) {
      // If compression fails, fallback to original file
      if (errorCallback) {
        errorCallback(error, file);
      } else {
        // If no error callback provided, use original file as fallback
        callback(file);
      }
    }
  });
};
